import { createContext, useContext } from 'react';

/**
 * Split from AiAssistantProvider for the same reason as chatPanelContext:
 * the provider lazy-imports the panel, and the panel must read the same
 * context object without importing the provider back.
 */
export const AiAssistantPanelContext = createContext(null);

export function useAiAssistantPanel() {
    const ctx = useContext(AiAssistantPanelContext);
    if (!ctx) {
        throw new Error(
            'useAiAssistantPanel must be used within AiAssistantProvider',
        );
    }
    return ctx;
}

/** Safe hook for layouts that may not mount the provider (e.g. tests). */
export function useAiAssistantPanelOptional() {
    return useContext(AiAssistantPanelContext);
}
